import { ComponentPropsWithoutRef } from 'react';
import { Button } from '@givebutter/primitives/button';
import { faCircle, faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { faCircleCheck as faCircleCheckSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useUpdateTask } from 'components/tasks/utils/useUpdateTask';
import { twMerge } from 'tailwind-merge';
import { Task } from 'types/domain';

interface CompleteTaskActionProps extends ComponentPropsWithoutRef<'button'> {
    task: Task;
}

const CompleteTaskAction = ({ task }: CompleteTaskActionProps) => {
    const { completed_at, status } = task;
    const { mutate: updateTaskStatus } = useUpdateTask();
    const isComplete = status === 'complete' && !!completed_at;

    return (
        <Button
            variant="transparent"
            size="xs"
            className="group/button z-layerFour p-0"
            onClick={() =>
                updateTaskStatus({
                    taskId: task.id,
                    params: { status: isComplete ? 'todo' : 'complete' },
                })
            }
        >
            <FontAwesomeIcon
                icon={isComplete ? faCircleCheckSolid : faCircle}
                className={twMerge(
                    'h-5 w-5 text-gray-300',
                    isComplete ? 'text-green-500' : 'group-hover/button:hidden',
                )}
            />
            <FontAwesomeIcon
                icon={faCircleCheck}
                className={twMerge(
                    'hidden h-5 w-5 text-green-500',
                    !isComplete && 'group-hover/button:block',
                )}
            />
        </Button>
    );
};

export { CompleteTaskAction };
